import React from 'react';

const Contact = () => {
  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Registered Office',
      details: ['Sfairou 1, 3118', 'Limassol, Cyprus']
    },
    {
      icon: 'fas fa-envelope',
      title: 'Email Us',
      details: ['info@polzenrom.com']
    }
  ];

  return (
    <section id="contact" className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">Contact Us</h2>
            <p className="lead text-muted">Ready to optimize your digital solutions? Get in touch with our team today.</p>
          </div>
        </div>
        
        <div className="row g-4 justify-content-center">
          {contactInfo.map((info, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="text-center">
                <div className="contact-icon mb-3">
                  <i className={`${info.icon} fa-3x text-primary`}></i>
                </div>
                <h5 className="fw-bold">{info.title}</h5>
                {info.details.map((detail, detailIndex) => (
                  <p key={detailIndex} className="text-muted mb-1">{detail}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
